$(document).ready(function(){
$('.owl-carousel').owlCarousel({
    loop:true,
    margin:24,
    autoplay: true,
    responsiveClass:true,
    nav:false,
    dots: false,
    center: true,
    responsive:{
        0:{
            items:2.1,
            margin:15,
        },
        500:{
           items:2.5,
        },
        700:{
           items:2.9,
        },
        900:{
           items:3.2,
        },
        1100:{
           items:3.9,
        },
        1500:{
            items:4.99,
        }
    }
})
});